import { defineModule } from "@modules/dynamic_import/utils/defineModule";
import { SDK_MODULES } from "@modules/sdk/constants";

export const GiftRegistrySdkDefinition = defineModule({
    name: SDK_MODULES.GIFT_REGISTRY,
    importCallback: () =>
        import(
            /* webpackChunkName: "GiftRegistrySdk" */ "@apps/gift_registry/gift_registry_sdk/GiftRegistrySdk"
        ),
});

export const WishlistsSdkDefinition = defineModule({
    name: SDK_MODULES.WISHLISTS,
    importCallback: () =>
        import(
            /* webpackChunkName: "WishlistsSdk" */ "@apps/wishlist/wishlists_sdk/WishlistsSdk"
        ),
});

export const ReviewsSdkDefinition = defineModule({
    name: SDK_MODULES.REVIEWS,
    importCallback: () =>
        import(
            /* webpackChunkName: "ReviewsSdk" */ "@apps/reviews/reviews_sdk/ReviewsSdk"
        ),
});

export const DiscountSdkDefinition = defineModule({
    name: SDK_MODULES.DISCOUNTS,
    importCallback: () =>
        import(
            /* webpackChunkName: "DiscountSdk" */ "@modules/discount/discount_sdk/DiscountSdk"
        ),
});

export const RewardsSdkDefinition = defineModule({
    name: SDK_MODULES.REWARDS,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsSdk" */ "@apps/rewards/rewards_sdk/RewardsSdk"
        ),
});

export const CartSdkDefinition = defineModule({
    name: SDK_MODULES.CART,
    importCallback: () =>
        import(
            /* webpackChunkName: "CartSdk" */ "@modules/cart/cart_sdk/CartSdk"
        ),
});

export const AuthenticationSdkDefinition = defineModule({
    name: SDK_MODULES.AUTHENTICATION,
    importCallback: () =>
        import(
            /* webpackChunkName: "AuthenticationSdk" */ "@modules/authentication/authentication_sdk/AuthenticationSdk"
        ),
});
